"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function DisclaimerOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section id="disclaimer-overview" ref={ref} className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-background py-20 md:py-32">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/modern_sunlit_architecture_detail.png)]" style={{
      filter: "blur(2px)"
    }}>
        <div className="absolute inset-0 bg-gradient-to-b from-white/90 via-white/70 to-white/90"></div>
      </div>

      {}
      <div className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <h1 className="text-[48px] md:text-[64px] leading-[1.1] font-bold tracking-[-0.03em] text-foreground mb-6">
          Legal Disclaimer &amp; Terms
        </h1>

        {}
        <p className="text-[18px] md:text-[20px] leading-[1.6] text-muted-foreground max-w-2xl mx-auto mb-10 tracking-[-0.01em]">
          Important information about the use of this website, intellectual property rights, and regulatory compliance. Please read carefully before proceeding.
        </p>

        {}
        <Button asChild size="lg" className="bg-primary text-foreground-primary hover:bg-primary hover:shadow-[0_0_20px_rgba(59,130,246,0.4)] transition-all duration-[var(--duration-fast)] ease-out rounded-[var(--radius-full)] px-8 py-4 text-[16px] font-semibold">
          <Link to="/LegalDisclaimerPage#legal-disclaimer">Read Full Disclaimer</Link>
        </Button>
      </div>
    </section>;
}